// /opt/isp_erp/frontend/src/pages/warehouse/DashboardPage.jsx
import React, { useEffect, useState } from "react";
import { Box, CircularProgress } from "@mui/material";
import { cargarContextoBodega } from "../../utils/contextoBodega";
import DashboardCentral from "./Dashboard";
import DashboardSucursalPanel from "../../components/warehouse/DashboardSucursalPanel";
import SucursalesResumenPanel from "../../components/warehouse/SucursalesResumenPanel";

/** Encargado: el dashboard de su sucursal. Central y administrador: el de siempre, con las sucursales encima. */
export default function DashboardPage() {
  const [ctx, setCtx] = useState(undefined);

  useEffect(() => {
    let vivo = true;
    cargarContextoBodega().then((c) => { if (vivo) setCtx(c || { central: true, sucursales: [] }); });
    return () => { vivo = false; };
  }, []);

  if (ctx === undefined) return (<Box sx={{ p: 6, textAlign: "center" }}><CircularProgress /></Box>);
  if (ctx.central === false) return <DashboardSucursalPanel />;
  return (
    <>
      {(ctx.sucursales || []).length > 0 && <SucursalesResumenPanel />}
      <DashboardCentral />
    </>
  );
}
